import React from 'react';
import FoundationSection from '../components/FoundationSection';

const Mission = () => (
  <FoundationSection
    title="Misión y Visión: Nuestro Compromiso"
    id="mission"
    imageSrc="/img6.jpg"
    imageAlt="Danza tradicional afrocolombiana"
    imagePosition="left"
  >
    <h3 className="text-2xl md:text-3xl font-semibold text-green-700 mb-4">🎯Nuestra Misión</h3>
    <p className="text-lg md:text-xl leading-relaxed mb-8">
      Contribuir al desarrollo social, económico y cultural de las comunidades afrocolombianas, raizales y palenqueras, promoviendo la inclusión, la equidad y la protección de los derechos humanos, a través de programas y proyectos sostenibles que mejoren la calidad de vida de poblaciones en situación de vulnerabilidad.
    </p>
    <h3 className="text-2xl md:text-3xl font-semibold text-green-700 mb-4">👁️Nuestra Visión</h3>
    <p className="text-lg md:text-xl leading-relaxed">
      Ser una fundación líder en Colombia y referente en América Latina por su compromiso con el fortalecimiento de las comunidades afrodescendientes, impulsando transformaciones sociales que garanticen un futuro digno, justo y con igualdad de oportunidades para todos.
    </p>
  </FoundationSection>
);

export default Mission;